import { useState } from 'react';
import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import SelectiveSyncPolicy from '../formFields/SelectiveSyncPolicy';
import DefaultTrunk from '../formFields/DefaultTrunk';
import DataResidencyRegion from '../formFields/DataResidencyRegion';
import EngineLocations from '../formFields/EngineLocations';
import useGetCompanyTrunks from '../../queries/useGetCompanyTrunks';
import { useCompanyForm } from '../../hooks/useCompanyForm';

const CompanyGeneralTCAPSettings = ({
    errors,
    touched,
    isAddMode,
    darkMode,
    engineLocations,
    isLoadingEngineLocations,
    dataResidencyLocations,
    isLoadingDataResidencyLocations,
}) => {
    const { formData } = useCompanyForm();
    const [trunks, setTrunks] = useState([]);

    // Fetch trunks for the company
    const { isLoading: isLoadingTrunks } = useGetCompanyTrunks(
        setTrunks,
        formData.id,
    );

    const formFields = (errors) => {
        const fields = [
            // Selective Sync Policy - Only in edit mode
            !isAddMode && (
                <SelectiveSyncPolicy
                    key="selectiveSyncPolicy"
                    errors={errors}
                    darkMode={darkMode}
                />
            ),

            // Default Trunk - Only in edit mode
            !isAddMode && (
                <DefaultTrunk
                    key="defaultTrunk"
                    errors={errors}
                    darkMode={darkMode}
                    trunks={trunks}
                    isLoadingTrunks={isLoadingTrunks}
                />
            ),

            // Data Residency Region - Only in edit mode
            !isAddMode && (
                <DataResidencyRegion
                    key="dataResidencyRegion"
                    darkMode={darkMode}
                    dataResidencyLocations={dataResidencyLocations}
                    isLoadingDataResidencyLocations={
                        isLoadingDataResidencyLocations
                    }
                />
            ),

            // Engine Locations - Only in edit mode
            !isAddMode && (
                <EngineLocations
                    key="engineLocations"
                    errors={errors}
                    darkMode={darkMode}
                    engineLocations={engineLocations}
                    isLoadingEngineLocations={isLoadingEngineLocations}
                />
            ),
        ];

        return fields;
    };

    // Filter out null/false values from conditional fields
    const filteredFields = formFields(errors, touched).filter(Boolean);

    return (
        <AccordionItemHandler
            index={1}
            key="companyTCAPSettings"
            label="TCAP Settings"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {filteredFields}
        </AccordionItemHandler>
    );
};

export default CompanyGeneralTCAPSettings;
